<template>
  <b-card>
    <b-card-title class="text-left">Active Workouts</b-card-title>
    <b-card-sub-title class="text-left">Synced to Your App</b-card-sub-title>

    <b-table
        striped
        small
        hover
        :items="data"
        :fields="fields"
        class="text-left mt-2"
        thead-tr-class="d-none"
    >
      <template #cell(name)="data">
        <span v-b-tooltip.hover.click="{customClass: 'workout-name-tooltip'}" :title="data.item.name">{{ data.item.name }}</span>
      </template>
      <template #cell(meta)="data">
        <Duration :duration="data.item.meta.duration"/>
      </template>
    </b-table>
  </b-card>
</template>

<script>

import Duration from "@/components/Duration.vue";

export default {

  name: 'UserWorkouts',
  components: {Duration},
  props: {
    uuid: String,
    compact: Boolean,
    showLink: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      data: [],
      fields: [
        {key: "name", tdClass: "workout-name text-truncate"},
        {key: "meta", tdClass: "text-nowrap text-right"},
      ],
    }
  },
  created() {
    this.$http.get(`/api/active-workouts`)
        .then(response => {
          this.data = response.data;
        })
        .catch(() => {
          // console.warn(e)
        });
  },
}
</script>

<style scoped>
/* max-width: 0 lets the cell shrink below its content so text-truncate can apply */
::v-deep .workout-name {
  width: 100%;
  max-width: 0;
}
</style>

<style>
/* Tooltips render outside this component, so this block can't be scoped */
.workout-name-tooltip .tooltip-inner {
  max-width: none;
  white-space: nowrap;
}
</style>
